export default __webpack_public_path__ + "static/media/Diamond_Edge_large_8.ebff8861.jpg";